import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CallEndIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 8.5C9.32 8.5 6.74 8.93 4.34 9.71C3.57 9.96 3 10.66 3 11.5V13.4C3 13.93 3.21 14.41 3.56 14.76L5.5 16.7C5.81 17 6.21 17.05 6.55 16.85C7.06 16.55 7.36 16 7.36 15.45V13.07C7.36 12.62 7.65 12.23 8.07 12.08C9.31 11.66 10.63 11.45 12 11.45C13.37 11.45 14.69 11.66 15.93 12.07C16.35 12.22 16.64 12.62 16.64 13.07V15.44C16.64 16 16.94 16.55 17.45 16.84C17.79 17.04 18.19 16.99 18.5 16.69L20.44 14.75C20.79 14.4 21 13.92 21 13.39V11.5C21 10.66 20.43 9.95 19.66 9.71C17.26 8.93 14.68 8.5 12 8.5Z"
      fill="currentColor"
    />
  </svg>
);

CallEndIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CallEndIcon);
